import "./App.css";
import React from "react";
import Home from "./components/Home";
import Signin from "./pages/Signin";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import { Route, Routes } from "react-router-dom";
import SignUp from "./pages/SignUp";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastProvider } from "./components/ToastContext";
import VerifyStudent from "./pages/VerifyStudent";
import Unauthorised from "./pages/Unauthorised";
import UnknownUser from "./pages/UnknownUser";

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ToastProvider>
        <div bkl="App" className="bg-white">
          <div>
            <Routes>
              <Route path="/*" element={<Home />} />
              <Route path="/verification/:token" element={<VerifyStudent />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />
              <Route path="/forget-password" element={<ForgetPassword />} />
              <Route path="/signin" element={<Signin />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/unauth" element={<Unauthorised />} />
              <Route path="/unknown" element={<UnknownUser />} />
            </Routes>
          </div>
        </div>
      </ToastProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
